import { render, staticRenderFns } from "./googleLogin.vue?vue&type=template&id=1d132740&"
import script from "./googleLogin.vue?vue&type=script&lang=js&"
export * from "./googleLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports